import { Button, Form, message, Input, Col, Row } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import tenantApis from 'api/tenantApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';
import { current_account } from 'helpers/authorizeHelper';
import { Switch } from 'antd';

export default function ListTenantsPage() {

  const [tenants, setTenants] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();

  async function fetchTenants(params={}) {
    setIsFetching(true);
    try {
      const res = await tenantApis.listing(params);
      if (res.code === 200) {
        setTenants(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchTenants()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchTenants(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchTenants(params)
  };

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'ID',
      width: '20rem',
      render: (record) => <span>{record.id}</span>
    },
    {
      title: 'Details',
      width: '32rem',
      render: (record) => (
        <div style={{ whiteSpace: 'pre-line', fontSize: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>Name:</strong> {record.name}
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Description:</strong> {record.description || <span style={{ color: '#888' }}>N/A</span>}
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>API Service:</strong> {record.enable_api_service ? <span style={{ color: '#52c41a' }}>Enabled</span> : <span style={{ color: '#f5222d' }}>Disabled</span>}
            <span style={{ marginLeft: 16 }}><strong>LVB Partner:</strong> {record.is_lvb_partner ? <span style={{ color: '#52c41a' }}>Yes</span> : <span style={{ color: '#888' }}>No</span>}</span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Referral Code:</strong> {record.referral_code || <span style={{ color: '#888' }}>N/A</span>}
            <span style={{ marginLeft: 16 }}><strong>Referred By:</strong> {record.referred_by_tenant_id || <span style={{ color: '#888' }}>N/A</span>}</span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <span style={{ marginLeft: 16 }}><strong>Store Commission:</strong> {record.commission_store_value}{record.commission_store_type === 'rate' ? '%' : ''}
            {record.enable_commission_store_after_first && (
              <span> (After 1st: {record.commission_store_value_after_first}{record.commission_store_type === 'rate' ? '%' : ''})</span>
            )}
            </span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <span style={{ marginLeft: 16 }}><strong>Reseller Rate:</strong> {record.reseller_commission_rate ? `${record.reseller_commission_rate}%` : <span style={{ color: '#888' }}>N/A</span>}</span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Usage Type:</strong> {record.usage_type}
            <span style={{ marginLeft: 16 }}><strong>Business Type:</strong> {record.business_type}</span>
            <span style={{ marginLeft: 16 }}><strong>Company Size:</strong> {record.company_size}</span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Website:</strong> <a href={/^https?:\/\//.test(record.website_url) ? record.website_url : `https://${record.website_url}`} target="_blank" rel="noopener noreferrer">{record.website_url}</a>
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Onboarding Status:</strong> {record.onboarding_status}
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Custom Domain:</strong> {record.custom_domain?.name ? (
              <span>
                <a href={`https://${record.custom_domain.name}`} target="_blank" rel="noopener noreferrer">{record.custom_domain.name}</a>
                <span style={{ marginLeft: 8, color: record.custom_domain.status === 'completed' ? '#52c41a' : '#faad14' }}>
                  ({record.custom_domain.status})
                </span>
              </span>
            ) : <span style={{ color: '#888' }}>N/A</span>}
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Feature Settings:</strong>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Membership: {record.feature_setting?.enable_membership ? 'Enabled' : 'Disabled'}</li>
              <li>Custom Payment: {record.feature_setting?.enable_custom_payment ? 'Enabled' : 'Disabled'}</li>
              <li>Custom Price: {record.feature_setting?.enable_custom_price ? `Enabled (${record.feature_setting?.custom_price_type})` : 'Disabled'}</li>
              <li>Trade Credit: {record.feature_setting?.enable_trade_credit ? 'Enabled' : 'Disabled'}</li>
              <li>Reseller: {record.feature_setting?.enable_reseller ? 'Enabled' : 'Disabled'}</li>
            </ul>
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Owner:</strong>
            <div style={{ marginLeft: 12, marginTop: 4 }}>
              <div><strong>Name:</strong> {record.owner?.name}</div>
              <div><strong>Email:</strong> {record.owner?.email}</div>
              <div><strong>Phone:</strong> {record.owner?.phone_number}</div>
              <div><strong>Status:</strong> <span style={{ color: record.owner?.status === 'active' ? '#52c41a' : '#faad14' }}>{record.owner?.status}</span></div>
              <div><strong>Last Login:</strong> {record.owner?.last_login_at ? fullDateTimeFormat(record.owner.last_login_at) : <span style={{ color: '#888' }}>N/A</span>}</div>
              {record.owner?.current_subscription && (
                <div style={{ marginTop: 6, background: '#f5f5f5', borderRadius: 6, padding: '8px 12px', border: '1px solid #e0e0e0' }}>
                  <div style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>Current Subscription</div>
                  <div style={{ fontSize: 13 }}>
                    <span><strong>Plan:</strong> {record.owner.current_subscription.plan_name}</span><br />
                    <span><strong>Status:</strong> {record.owner.current_subscription.status}</span><br />
                    <span><strong>Remaining Days:</strong> {record.owner.current_subscription.remaining_days}</span><br />
                    <span><strong>Start:</strong> {fullDateTimeFormat(record.owner.current_subscription.start_date)}</span><br />
                    <span><strong>End:</strong> {fullDateTimeFormat(record.owner.current_subscription.end_date)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )
    },
    {
      title: 'created_at',
      width: '7rem',
      key: 'created_at',
      sorter: true,
      render: (record) => <span>{fullDateTimeFormat(record.created_at)}</span>
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả tenants"
        pageHeaderExtras={
          <>
            <Button type="primary">
              Thêm
            </Button>
          </>
        }
      />
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='id'
                label='id'
              >
                <Input placeholder="Tìm theo id" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='domain_name'
                label='Domain Name'
              >
                <Input placeholder="Tìm theo domain name" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='is_lvb_partner'
                label='LVB Partner'
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
            <Col
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={tenants}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
    </>
  );
}


